import { Payments } from '../helpers';
import QantasPointsLineItem from './QantasPointsLineItem';
import CashLineItem from './CashLineItem';
import CreditVoucherLineItem from './CreditVoucherLineItem';
import { CreditCardPaymentMethod, CreditNotePaymentMethod, PointsPaymentMethod, QantasGroupCreditVoucherPaymentMethod } from 'types';
import QantasTravelPassLineItem from './QantasTravelPassLineItem';

export interface PaidLineItemsProps {
  transactionAmounts: Payments;
}

const PaidLineItems = ({ transactionAmounts }: PaidLineItemsProps) => (
  <>
    {transactionAmounts.map((transaction, index) => {
      switch (transaction.method) {
        case 'points':
          return (
            <QantasPointsLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              qffNumber={(transaction as PointsPaymentMethod).qffNumber}
              total={transaction.total}
            />
          );
        case 'credit_card':
          return (
            <CashLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              cardType={(transaction as CreditCardPaymentMethod).cardType}
              cardNumber={(transaction as CreditCardPaymentMethod).lastFourDigits}
              total={transaction.total}
            />
          );
        case 'credit_note':
          return (
            <CreditVoucherLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              voucherCode={(transaction as Pick<CreditNotePaymentMethod, 'lastFourCharacters'>).lastFourCharacters}
              total={transaction.total}
            />
          );
        case 'qantas_group_credit_voucher':
          return (
            <QantasTravelPassLineItem
              key={`paid-line-item-${index}`}
              type={transaction.type}
              createdAt={transaction.createdAt}
              cardNumber={(transaction as unknown as QantasGroupCreditVoucherPaymentMethod).cardNumber}
              total={transaction.total}
            />
          );
        default:
          return null;
      }
    })}
  </>
);

export default PaidLineItems;
